import { render } from "./CustomInputUrl.vue?vue&type=template&id=24ae7b2a"
import script from "./CustomInputUrl.vue?vue&type=script&lang=js"
export * from "./CustomInputUrl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__